import styled from '../../../config/theme'

const Container = styled.div`
  padding: 0 20px;
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
`

const MessageContainer = styled.div<{ type: 'sent' | 'received' }>`
  max-width: 45%;
  ${props => props.type === 'sent' ? 'margin-left: auto; margin-right: 0;' : 'margin-left: 0; margin-right: auto;'};

  margin-top: 1px;
  margin-bottom: 1px;

  display: block;
  float: ${props => props.type === 'sent' ? 'right;' : 'left;'};
  text-align: ${props => props.type === 'sent' ? 'right;' : 'left;'};

  width: 100%;

  > span {
    justify-content: ${props => props.type === 'sent' ? 'flex-end;' : 'flex-start;'};
  }
`

const Baloon = styled.div<{ type: 'sent' | 'received', isFirstSentFromUser: boolean, isLastSentFromUser: boolean, read?: boolean, full: boolean }>`
  background: ${props => props.type === 'sent' ? props.theme.color.lightBluishGray : props.theme.color.white};
  border: 1px solid ${props => props.type === 'sent' ? props.theme.color.lightBluishGray : props.theme.color.lightGray};
  max-width: 100%;
  border-radius: 18px;
  min-height: 36px;

  display: inline-flex;
  align-items: center;

  padding: 10px;

  ${props => props.full && 'width: 100%;'}

  ${props => props.type === 'received' && `
    ${!props.read ? `
      transform: translateX(600%) scaleY(0);
      opacity: 0;
      transition: all 1s;
    ` : `
      transform: translate(0,0) rotateZ(0) scaleY(1);
      opacity: 1;
      transition: all 1s;
    `}
  `}

  + span {
    color: ${props => props.theme.color.gray};
    font-size: ${props => props.theme.fontSize.hint};
  }

  ${props => props.isFirstSentFromUser && `
    ${props.type === 'sent' ? `
      border-top-right-radius: 18px;
      border-bottom-right-radius: 5px;
    ` : `
      border-top-left-radius: 18px;
      border-bottom-left-radius: 5px;
    `}
  `}
  ${props => props.isLastSentFromUser && `
    ${props.type === 'sent' ? `
      border-top-right-radius: 5px;
      border-bottom-right-radius: 18px;
    ` : `
      border-top-left-radius: 5px;
      border-bottom-left-radius: 18px;
    `}
  `}
  ${props => (!props.isFirstSentFromUser && !props.isLastSentFromUser) && `
    ${props.type === 'sent' ? `
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    ` : `
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    `}
  `}
  ${props => (props.isFirstSentFromUser && props.isLastSentFromUser) && `
    ${props.type === 'sent' ? `
      border-top-right-radius: 18px;
      border-bottom-right-radius: 18px;
    ` : `
      border-top-left-radius: 18px;
      border-bottom-left-radius: 18px;
    `}
  `}
`

const NoMessages = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 50px 0;

  > img {
    height: 200px;
    width: 200px;
    object-fit: contain;
  }

  > * {
    margin-bottom: 20px;
  }
  > span {
    color: ${props => props.theme.color.gray};
  }
`

const Audio = styled.div<{ type: 'sent' | 'received' }>`
  width: 100%;
  margin: -20px 0;
  /* background: ${props => props.type === 'sent' ? props.theme.color.lightBluishGray : props.theme.color.white}; */
  border-radius: 18px;

  display: flex;
  justify-content: center;
  align-items: center;
`

const Image = styled.img<{ type: 'sent' | 'received' }>`
  max-width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  vertical-align: middle;
`

const Document = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  text-decoration: none;
  color: ${props => props.theme.color.blue};
  width: 100%;

  > img {
    margin-right: 10px;
  }

  > span {
    display: inline;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: pre;
    word-break: keep-all;
    flex: 1;
  }
`

const Geolocation = styled.iframe`
  width: 100%;
  border-radius: 8px;
  height: 200px;
`

const Text = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

const RealtyContainer = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const RealtyButton = styled.button`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  margin-top: 10px;
  padding: 0;
  border: none;
  justify-content: space-evenly;
  cursor: pointer;

  > div {
    padding: 5px;
    > p {
      margin: 2px 0;
      font-size: 12px;
      > span {
        font-size: 12px;
      }
    }
    > h2 {
      display: none;
    }
    > button {
      display: none;
    }
  }
`

const Progress = styled.div<{ total: number, current: number }>`
  width: 200px;
  height: 4px;
  background: #9E9E9E;
  border-radius: 10px;
  position: relative;
  margin: 0 5px;

  &:before {
    content: '';

    position: absolute;
    top: -4px;
    right: calc(${props => (props.total - props.current) / props.total * 100}% - 10px);

    background: ${props => props.theme.color.darkGray};
    height: 12px;
    width: 12px;
    border-radius: 12px;
  }

  + span {
    margin-top: 3px;
  }
`

export { Container, MessageContainer, Baloon, NoMessages, Audio, Image, Document, Geolocation, Text, RealtyContainer, RealtyButton, Progress, }

